export enum ChargeOccurrenceType {
  Daily = "Daily",
  Weekly = "Weekly",
  Monthly = "Monthly",
}